const ratingStyle = Object.freeze({});

export default ratingStyle;
